import React from 'react';

const CustomAlert = ({ message, type }) => {
  return (
    <div className={`custom-alert ${type}`}>
      <p>{message}</p>
    </div>
  );
};

export default CustomAlert;